"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDisabledSubmit = void 0;
const react_1 = require("react");
const useDisabledSubmit = ({ errors, submitCount, wantNextStep, isShowOtp, otpAffectsSubmit = true, }) => {
    const [disabled, setDisabled] = (0, react_1.useState)(false);
    const hasErrors = Boolean(Object.keys(errors).length);
    (0, react_1.useEffect)(() => {
        if (disabled) {
            setDisabled(hasErrors);
        }
    }, [hasErrors]);
    (0, react_1.useEffect)(() => {
        if (hasErrors) {
            setDisabled(true);
        }
    }, [submitCount]);
    (0, react_1.useEffect)(() => {
        if (isShowOtp && otpAffectsSubmit) {
            setDisabled(hasErrors);
        }
    }, [isShowOtp, hasErrors, otpAffectsSubmit]);
    (0, react_1.useEffect)(() => {
        if (wantNextStep) {
            setDisabled(false);
        }
    }, [wantNextStep]);
    return disabled;
};
exports.useDisabledSubmit = useDisabledSubmit;
